import script from "./psiShopReturnGoodsOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./psiShopReturnGoodsOrder.vue?vue&type=script&setup=true&lang=js"

import "./psiShopReturnGoodsOrder.vue?vue&type=style&index=0&id=50d2f77a&scoped=true&lang=css"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50d2f77a"]])

export default __exports__